import React from 'react'
import { Link, useNavigate, useLocation } from 'react-router-dom'
import { useAuth } from '../../contexts/authContext'
import { doSignOut } from '../../firebase/auth'

import { KeyRound, Briefcase, Ticket, User, LogOut } from 'lucide-react'



const Header = () => {
    const navigate = useNavigate()
    const { userLoggedIn } = useAuth()
    const location = useLocation()

    return (
        <nav className="flex justify-between items-center w-full fixed top-0 left-0 h-12 bg-white border-b px-4 shadow-md z-20">
            {/* Left-side Navigation with Fixify FM Work */}
            <div className="text-blue-600 font-bold text-lg cursor-pointer" onClick={() => navigate('/home')}>
                Fixify FM Work
            </div>

            {/* Center Navigation */}
            <div className="flex gap-x-6 justify-center items-center">
                {userLoggedIn && (
                    <>
                        <Link
                            to="/assets"
                            className={`flex flex-col items-center ${location.pathname === "/assets" ? "text-blue-600 font-bold" : "text-gray-700"
                                }`}
                        >
                            <Briefcase size={24} />
                            <span className="text-xs">Assets</span>
                        </Link>

                        <Link
                            to="/tickets"
                            className={`flex flex-col items-center ${location.pathname === "/tickets" ? "text-blue-600 font-bold" : "text-gray-700"
                                }`}
                        >
                             <Ticket size={24} />
                             <span className="text-xs">Tickets</span>
                        </Link>

                        <Link
                            to="/profile"
                            className={`flex flex-col items-center ${location.pathname === "/profile" ? "text-blue-600 font-bold" : "text-gray-700"
                                }`}
                        >
                            <User size={24} />
                            <span className="text-xs">Profile</span>
                        </Link>
                    </>
                )}
            </div>

            {/* Right-side Logout / Auth Buttons */}
            <div className="flex items-center">
                {userLoggedIn ? (
                    <button
                        onClick={() => {
                            doSignOut().then(() => {
                                navigate('/login', { replace: true }) // Prevents going back
                            })
                        }}
                    >
                        <LogOut size={24} />
                    </button>
                ) : (
                    <div className="flex gap-x-4">
                        <Link className="text-sm text-blue-600 underline" to={'/login'}>
                            
                        <KeyRound size={24} />
                        </Link>
                        {/* <Link className="text-sm text-blue-600 underline" to={'/register'}>
                            Register
                        </Link> */}
                    </div>
                )}
            </div>
        </nav>
    )
}

export default Header
